import React, { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import { useGlobal } from '../../../contexts/Global/context';

import linkLists from './schema';

import Icon from '../../../components/Icons';
import * as S from './styles';

function QuickAccess() {
    const { dataActiveContract, contrastTheme } = useGlobal();

    const [accessList, setAccessList] = useState();

    const list = linkLists.map(({ name, path, useToSpecificContract }) => {
        if (dataActiveContract.isSpecificContract && !useToSpecificContract) {
            return <React.Fragment key={name} />;
        }

        return (
            <Link key={name} to={path}>
                <S.LinkItem>
                    <Icon name="ArrowRight" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                    <span>{name}</span>
                </S.LinkItem>
            </Link>
        );
    });

    useEffect(() => {
        setAccessList(list);
    }, []);

    return <S.LinksContainer>{accessList}</S.LinksContainer>;
}

export default QuickAccess;
